import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const SyncSchedulePage = lazy(() => import('~/features/organization/pages/sync-schedule-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/sync-schedule')({
  beforeLoad: requirePermission('organization_sync_schedule'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SyncSchedulePage />
    </Suspense>
  ),
});
